"use client";

import React, { useRef, type RefObject } from "react";
import { Dialog } from "@/components/common/Dialog";
import { searchTipsFallbackContent } from "./search-tips-fallback-content";

interface SearchTipsModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  content?: string;
  returnFocusRef?: RefObject<HTMLElement | null>;
}

export function SearchTipsModal({
  open,
  onClose,
  title,
  content,
  returnFocusRef,
}: SearchTipsModalProps) {
  const contentRef = useRef<HTMLDivElement | null>(null);

  const finalTitle = title ?? "Search tips";
  const finalContent = content ?? searchTipsFallbackContent;

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onClose();
      }}
      title={finalTitle}
      initialFocusRef={contentRef}
      returnFocusRef={returnFocusRef}
    >
      <div
        ref={contentRef}
        className="searchTipsContent"
        tabIndex={0}
        dangerouslySetInnerHTML={{ __html: finalContent }}
      />
    </Dialog>
  );
}
